import clsx from 'clsx';
import { Icon } from './Icon.jsx';

const tones = {
  orange: 'bg-orange-soft text-orange-deep',
  cyan: 'bg-[#CFFAFE] text-[#0E7490]',
  pink: 'bg-[#FCE7F3] text-[#BE185D]',
  yellow: 'bg-[#FEF3C7] text-[#92400E]',
  green: 'bg-[#DCFCE7] text-[#15803D]',
  purple: 'bg-[#EDE9FE] text-[#6D28D9]'
};

export function KPI({ label, value, delta, icon = 'reports', tone = 'orange', deltaDirection = 'up', className = '' }) {
  return (
    <div className={clsx('card relative overflow-hidden p-4', className)}>
      <div className={clsx('absolute top-3.5 left-3.5 w-10 h-10 rounded-[12px] grid place-items-center', tones[tone])}>
        <Icon name={icon} size={20} />
      </div>
      <div className="text-xs text-ink-2 font-medium pr-12">{label}</div>
      <div className="text-[28px] font-extrabold tracking-tight mt-1.5">{value}</div>
      {delta ? (
        <div className={clsx('text-[11.5px] font-semibold', deltaDirection === 'down' ? 'text-red' : 'text-green')}>
          {delta}
        </div>
      ) : null}
    </div>
  );
}
